import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { currentCompanyDateFormatSelector } from 'domain/companies';
import { SYMBOL_FOR_EMPTY_CELL } from 'components/AgGrid/helpers';

const useAgGridColumnTypes = () => {
  const dateFormat = useSelector(currentCompanyDateFormatSelector);

  return useMemo(
    () => ({
      string: {
        valueFormatter: ({ value }) => (value != null && value !== '' ? value : SYMBOL_FOR_EMPTY_CELL),
      },
      // Vendor-level withholding tax — numeric percentage (0–100), editable inline.
      percent: {
        cellEditor: 'withholdingTaxCellEditor',
        cellRenderer: 'vendorFieldCellRenderer',
        cellStyle: { textAlign: 'right' },
        valueFormatter: ({ value }) => (value != null && value !== '' ? `${value}%` : SYMBOL_FOR_EMPTY_CELL),
      },
      // Vendor-level "valid until" — date (not earlier than today), editable inline.
      date: {
        cellEditor: 'validUntilDateCellEditor',
        cellRenderer: 'vendorFieldCellRenderer',
        cellStyle: { textAlign: 'right' },
        valueFormatter: ({ value }) =>
          value ? moment(value).format(dateFormat) : SYMBOL_FOR_EMPTY_CELL,
      },
    }),
    [dateFormat],
  );
};

export default useAgGridColumnTypes;
